<template>
  <tr class="attachable-note-row">
    <td>
      <ShowNoteModalComponent :note-id="noteId"
                              v-if="showModalVisible && noteId !== null"
                              :visible="showModalVisible"
                              @close="closeShowModal"/>
      <span style="text-overflow: ellipsis; display:inline-block; max-width:200px;">
          <a @click.prevent="openShowModal" v-if="canShow" class="show-note-modal" title="Bekijk notitie">
            {{ name }}
          </a>
          <span v-else>
          {{ name }}
          </span>
          <div class="title" style="font-size: 18px">
            <ShowProductLabelComponent v-for="(productLabel, key) in productLabels" :key="key"
                                       :product-label="productLabel"/>
          </div>
        </span>
    </td>
    <td>
      <a-tooltip placement="top">
        <template slot="title">
          {{ parentName }}
        </template>
        <span class="limit-text">
        <a :href="parentShowLink">{{ parentName }}</a>
      </span>
      </a-tooltip>
    </td>
    <td>
      {{ date }}
    </td>
    <td>
      <UserBadgeComponent :user="user" v-if="createdByUser"/>
      <span v-if="createdBySystem">Systeem</span>
      <span v-if="createdByAdn">ADN</span>
      <span v-if="createdByHdn">HDN</span>
    </td>
    <td class="compact">
      <eye-icon v-if="attachable.visible_for_customer" style="color: #6dc287;"></eye-icon>
      <eye-off-icon v-if="!attachable.visible_for_customer" style="color: #a2a2a2;"></eye-off-icon>
    </td>
    <td class="text-right">
      <a-dropdown class="actions" data-dusk="note-options" :trigger="['click']" v-on:click.stop placement="bottomRight">
        <a-button type="default" @click.stop="e => e.preventDefault()">
          Acties
          <a-icon type="down"/>
        </a-button>

        <a-menu slot="overlay">
          <a-menu-item key="download" data-dusk="open-note" @click="openShowModal">
            <eye-icon></eye-icon>
            Bekijken
          </a-menu-item>
          <a-menu-item key="copy" data-dusk="edit-note" @click="openEditModal">
            <pencil-icon></pencil-icon>
            Bewerken
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="delete" data-dusk="delete-note" v-on:click="onDelete">
            <delete-icon></delete-icon>
            Verwijderen
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <EditNoteModalComponent :note-id="noteId" v-if="editModalVisible && noteId !== null" :visible="editModalVisible"
                              v-on:close="closeEditModal" v-on:note-updated="handleUpdated"/>
    </td>
  </tr>
</template>
<script>
import UserBadgeComponent from '../../user/components/BadgeComponent'
import ShowNoteModalComponent from './ShowNoteModalComponent'
import EditNoteModalComponent from './EditNoteModalComponent'
import ShowProductLabelComponent from '~/modules/product_label/components/ShowProductLabelComponent'

const moment = require('moment')

export default  {
  name: 'NoteTableRowComponent',
  components: {
    UserBadgeComponent,
    ShowNoteModalComponent,
    EditNoteModalComponent,
    ShowProductLabelComponent
  },
  props: {
    attachable: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editing: false,
      updateNameLoading: false,
      processLoading: false,
      unmatchLoading: false,
      showModalVisible: false,
      editModalVisible: false
    }
  },
  methods: {
    closeShowModal () {
      this.showModalVisible = false
    },
    openShowModal () {
      this.showModalVisible = true
    },
    openEditModal () {
      this.editModalVisible = true
    },
    closeEditModal () {
      this.editModalVisible = false
    },
    handleUpdated () {
      this.closeEditModal()
      this.$emit('note-updated')
    },
    async onDelete () {
      this.loading = true
      await this.$emit('delete', this.attachable)
    },
  },
  computed: {
    productLabels () {
      if (this.childInstance !== null && typeof this.childInstance.product_labels !== 'undefined' && this.childInstance.product_labels !== null) {
        return this.childInstance.product_labels.data
      }
      return []
    },
    childInstance () {
      return this.attachable.child_instance.data
    },
    parentInstance () {
      if (this.hasParentInstance) {
        return this.attachable.parent_instance.data
      }
    },
    hasParentInstance () {
      return (typeof this.attachable.parent_instance !== 'undefined' && this.attachable.parent_instance !== null)
    },
    name () {
      return this.childInstance.name
    },
    date () {
      return moment(this.childInstance.date, moment.ISO_8601).format('D-MM-YYYY HH:mm:ss')
    },
    size () {
      return this.childInstance.size
    },
    canShow () {
      return typeof this.childInstance.show_link !== 'undefined'
    },
    showLink () {
      return this.childInstance.show_link
    },
    parentShowLink () {
      if (this.hasParentInstance) {
        return this.parentInstance.uri
      }
    },
    parentName () {
      if (this.hasParentInstance) {
        return this.parentInstance.name
      }
    },
    createdByUser () {
      return this.attachable.created_by_type === 'user'
    },
    createdBySystem () {
      return this.attachable.created_by_type === 'system'
    },
    createdByHdn () {
      return this.attachable.created_by_type === 'hdn'
    },
    createdByAdn () {
      return this.attachable.created_by_type === 'adn'
    },
    creatorId () {
      return this.attachable.created_by_id
    },
    noteId () {
      return this.childInstance.id
    },
    user () {
      if (this.createdByUser) {
        return this.attachable.owner.data
      }
    },
  }
}
</script>

<style scoped>
.attachable-show-component {
  padding: 15px 10px;
  border: solid 1px #ccc;
  border-radius: 4px;
}

.limit-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

</style>
